import { styled } from '@mui/material/styles';

export const Text = styled('p', {
  shouldForwardProp: prop => prop !== 'small'
})(({ theme, small }) => ({
  margin: 0,
  ...(small && { fontSize: theme.fontSize.xsmall }),
  '& em': {
    wordBreak: 'break-all',
    fontStyle: 'normal',
    fontWeight: theme.fontWeight.bold
  },
  '& span': {
    wordBreak: 'break-all'
  }
}));

export const TextWrapper = styled('div')(() => ({
  lineHeight: '1.5em'
}));

export const Container = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  [`& ${TextWrapper}`]: {
    flexGrow: 1
  }
}));
